import React, { useEffect, useState } from 'react';
import './LeadCaptureForm.css';

const ThankYou = () => {
    const [leadId, setLeadId] = useState(null);
    
    useEffect(() => {
        // Get lead ID from session storage
        const storedLeadId = sessionStorage.getItem('leadId');
        if (storedLeadId) {
            setLeadId(storedLeadId);
            // Clear it after reading
            sessionStorage.removeItem('leadId');
        }
    }, []);
    
    return (
        <div className="lead-capture-page">
            <div className="form-container thank-you-container">
                <div className="thank-you-icon">✓</div>
                
                <h2>Thank You for Your Interest!</h2>
                
                <p style={{ fontSize: '1.1rem', color: '#666', marginBottom: '2rem' }}>
                    We've received your request and are excited to help you build a quantitative cybersecurity risk management program.
                </p>
                
                <div className="next-steps">
                    <h3>What Happens Next?</h3>
                    <ol>
                        <li>
                            <strong>Invoice Delivery (Within 1 Business Day)</strong>
                            <br />
                            You'll receive a professional invoice via email with payment instructions. 
                            We accept wire transfer, ACH, check, or credit card.
                        </li>
                        <li>
                            <strong>Review & Payment</strong>
                            <br />
                            Take your time to review the invoice with your team. Standard payment terms are Net 30.
                        </li>
                        <li>
                            <strong>Account Activation</strong>
                            <br />
                            Once we receive payment, we'll activate your CISO Advisor account and send you login credentials.
                        </li>
                        <li>
                            <strong>Onboarding & Setup</strong>
                            <br />
                            Our team will schedule a kickoff call to help you get started with data collection and your first security assessment.
                        </li>
                    </ol>
                </div>
                
                <div style={{ background: '#f0f8ff', padding: '1.5rem', borderRadius: '10px', marginTop: '2rem' }}>
                    <h3 style={{ marginTop: 0, color: '#3498db' }}>Beta Customer Benefits</h3>
                    <ul style={{ paddingLeft: '1.5rem', margin: 0 }}>
                        <li>25% discount locked in for life</li>
                        <li>Priority feature requests</li>
                        <li>Free upgrade to next tier for 3 months</li>
                        <li>Quarterly executive briefings</li>
                        <li>Optional case study participation ($5K credit)</li>
                        <li>Advisory board invitation</li>
                    </ul>
                </div>
                
                <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                    <p style={{ color: '#666', marginBottom: '1rem' }}>
                        Questions? We're here to help.
                    </p>
                    <p style={{ fontSize: '1.1rem' }}>
                        <strong>Phil Moyer, Founder</strong><br />
                        <a href="mailto:phil@cisoadvisor.com" style={{ color: '#3498db', textDecoration: 'none' }}>
                            phil@cisoadvisor.com
                        </a>
                    </p>
                </div>
                
                <div className="button-group" style={{ marginTop: '2rem' }}>
                    <button 
                        type="button" 
                        className="btn btn-primary"
                        onClick={() => window.location.href = '/'}
                    >
                        Return to Home
                    </button>
                </div>
                
                {leadId && (
                    <p style={{ textAlign: 'center', marginTop: '1rem', fontSize: '0.85rem', color: '#999' }}>
                        Reference ID: #{leadId}
                    </p>
                )}
            </div>
        </div>
    );
};

export default ThankYou;
